import { Skeleton } from "@/components/ui/skeleton";

const DRABPE_LOGO = "https://tse3.mm.bing.net/th/id/OIP.lkjlDW60FNg7E3UYX8C4BAAAAA?rs=1&pid=ImgDetMain&o=7&rm=3";

export function DrabpeLoader() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background">
      <div className="w-full max-w-3xl px-6">
        <div className="flex items-center gap-4 mb-8">
          <img
            src={DRABPE_LOGO}
            alt="DRABPE"
            className="h-16 w-auto object-contain"
            loading="lazy"
            decoding="async"
          />
          <div>
            <div className="text-sm font-semibold tracking-[0.2em] text-muted-foreground">DRABPE</div>
            <div className="text-2xl font-display font-bold text-foreground">Loading the Directory</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="p-5 rounded-2xl border border-border bg-card">
              <Skeleton className="h-5 w-1/2 mb-3" />
              <Skeleton className="h-4 w-full mb-2" />
              <Skeleton className="h-4 w-5/6 mb-4" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-8 w-8 rounded-full" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
